// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"146":"51631496","247":"9e6f0f97","520":"7335db9b","829":"4504e581"}[chunkId] + ".css";
};